import { render } from "./PointCardTask.vue?vue&type=template&id=5a392c1e"
import script from "./PointCardTask.vue?vue&type=script&lang=js"
export * from "./PointCardTask.vue?vue&type=script&lang=js"

import exportComponent from "E:\\project\\exam\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__